import { createFileRoute } from "@tanstack/react-router";
import { CRYSTAL_RIVER_SHINGLE_STUDY as study } from "@/components/site/case-studies";
import { ProjectStudyPage, projectStudyHead } from "@/components/site/CaseStudy";

export const Route = createFileRoute("/projects/blue-shingle-roof-crystal-river-fl")({
  head: () => projectStudyHead(study),
  component: Page,
});

function Page() {
  return <ProjectStudyPage study={study} />;
}
